
<app-button-close-dialog></app-button-close-dialog>
<h2 mat-dialog-title>Acción realizada :: <strong>{{ data.accion == accionesDialog.Agregar ? 'Crear' : data.accion ==
    accionesDialog.Eliminar ? 'Eliminar': data.accion == accionesDialog.Ver
    ? 'Ver' : 'Modificar' }} Prueba Confesional</strong></h2>

<!-- Spinners para diferentes operaciones -->
<ngx-spinner [zIndex]="100" name="spCrearPruebaConfesional" bdColor="rgba(255,255,255,0.8)" size="default"
  color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>

<ngx-spinner [zIndex]="100" name="spModificarPruebaConfesional" bdColor="rgba(255,255,255,0.8)" size="default"
  color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>

<ngx-spinner [zIndex]="100" name="spEliminarPruebaConfesional" bdColor="rgba(255,255,255,0.8)" size="default"
  color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>

<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion != accionesDialog.Ver">

  <form [formGroup]="form">
    <ng-container *ngIf="data.accion == accionesDialog.Eliminar; else formTemplate">
      <div class="delete-confirmation">
        <mat-icon class="warning-icon">warning</mat-icon>
        <p>¿Está seguro que desea eliminar la prueba confesional <strong>{{data.descripcion}}</strong>?</p>
        <p class="delete-warning">Esta acción no se puede deshacer.</p>
      </div>
    </ng-container>

    <ng-template #formTemplate>
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" dynamicHeight>

        <!-- Tab 1: Información Básica -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">info</mat-icon>
            Información Básica
          </ng-template>
          <mat-card>
            <mat-card-header>
              <div mat-card-avatar>
                <mat-icon>title</mat-icon>
              </div>
              <mat-card-title>Datos Principales</mat-card-title>
              <mat-card-subtitle>Información esencial del acceso rápido</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <div class="row">
                <div class="col-sm-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Descripción</mat-label>
                    <input placeholder="Descripción de la prueba confesional" type="text" formControlName="Descripcion"
                      matInput />
                    <mat-error *ngIf="f.Descripcion.errors?.['required']">Este campo es
                      <strong>requerido</strong>.</mat-error>
                    <mat-error *ngIf="f.Descripcion.errors?.['maxlength']">Máximo 500 caracteres.</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Observaciones</mat-label>
                    <textarea placeholder="Observaciones adicionales" formControlName="Observaciones" matInput
                      rows="4"></textarea>
                    <mat-error *ngIf="f.Observaciones.errors?.['maxlength']">Máximo 1000 caracteres.</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </mat-tab>

        <!-- Tab 2: Personas Involucradas -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">people</mat-icon>
            Personas
          </ng-template>
          <mat-card appearance="outlined">
            <mat-card-header>
              <div mat-card-avatar>
                <mat-icon>person</mat-icon>
              </div>
              <mat-card-title>Persona Absolvente</mat-card-title>
              <mat-card-subtitle></mat-card-subtitle>
            </mat-card-header>

            <mat-card-content>
              <div class="row">
                <div class="col-sm-12">
                  <app-buscar-persona [personaEntrada]="personaAbsolventeSeleccionada" [disable]="false"
                    nombre="Absolvente" (eventEntity)="onPersonaAbsolventeSelected($event)">
                  </app-buscar-persona>
                  <mat-error *ngIf="!personaAbsolventeSeleccionada && form.get('IdPersonaAbsolvente')?.touched">
                    La persona absolvente es <strong>requerida</strong>.
                  </mat-error>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <ngx-spinner [zIndex]="-1" name="spBusquedaUsuarios" bdColor="rgba(255,255,255,0.8)" size="small"
                      color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                    <mat-label>Usuario Responsable</mat-label>
                    <mat-select placeholder="Seleccione un usuario" formControlName="IdUsuarioResponsable">
                      <mat-option [value]="usuario.id"
                        *ngFor="let usuario of usuarios; let i = index; trackBy: trackByItems">
                        {{ usuario.nombre }} {{ usuario.apellido }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="f.IdUsuarioResponsable.errors?.['required']">Este campo es
                      <strong>requerido</strong>.</mat-error>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <ngx-spinner [zIndex]="-1" name="spBusquedaTiposIntervinientes" bdColor="rgba(255,255,255,0.8)"
                      size="small" color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                    <mat-label>Tipo de Interviniente</mat-label>
                    <mat-select placeholder="Seleccione un tipo" formControlName="IdTipoInterviniente">
                      <mat-option [value]="tipo.id"
                        *ngFor="let tipo of tiposIntervinientes; let i = index; trackBy: trackByItems">
                        {{ tipo.descripcion }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <ngx-spinner [zIndex]="-1" name="spBusquedaEstados" bdColor="rgba(255,255,255,0.8)" size="small"
                      color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                    <mat-label>Estado de Prueba</mat-label>
                    <mat-select placeholder="Seleccione un estado" formControlName="IdEstadoPrueba">
                      <mat-option [value]="estado.id"
                        *ngFor="let estado of estadosPrueba; let i = index; trackBy: trackByItems">
                        {{ estado.descripcion }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </mat-tab>

        <!-- Tab 3: Fechas de Audiencia -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">event</mat-icon>
            Fechas de Audiencia
          </ng-template>

          <mat-card appearance="outlined">
            <mat-card-header>
              <div mat-card-avatar>
                <mat-icon>event</mat-icon>
              </div>
              <mat-card-title>Gestión de Audiencia Confesional</mat-card-title>
              <mat-card-subtitle></mat-card-subtitle>
            </mat-card-header>

            <mat-card-content>
              <div class="row">
                <div class="col-sm-12 col-md-4">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha de Audiencia</mat-label>
                    <input matInput [matDatepicker]="pickerAudiencia" formControlName="FechaAudiencia"
                      placeholder="Seleccione fecha">
                    <mat-datepicker-toggle matSuffix [for]="pickerAudiencia"></mat-datepicker-toggle>
                    <mat-datepicker #pickerAudiencia></mat-datepicker>
                    <mat-hint>Fecha programada para la audiencia confesional</mat-hint>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-4">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha Cédula Presentación</mat-label>
                    <input matInput [matDatepicker]="pickerCedulaPresentacion" formControlName="FechaCedulaPresentacion"
                      placeholder="Seleccione fecha">
                    <mat-datepicker-toggle matSuffix [for]="pickerCedulaPresentacion"></mat-datepicker-toggle>
                    <mat-datepicker #pickerCedulaPresentacion></mat-datepicker>
                    <mat-hint>Fecha de presentación de la cédula</mat-hint>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-4">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha Cédula Notificación</mat-label>
                    <input matInput [matDatepicker]="pickerCedulaNotificacion" formControlName="FechaCedulaNotificacion"
                      placeholder="Seleccione fecha">
                    <mat-datepicker-toggle matSuffix [for]="pickerCedulaNotificacion"></mat-datepicker-toggle>
                    <mat-datepicker #pickerCedulaNotificacion></mat-datepicker>
                    <mat-hint>Fecha de notificación de la cédula</mat-hint>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </mat-tab>

      </mat-tab-group>
    </ng-template>
  </form>

</mat-dialog-content>

<!-- Vista de solo lectura -->
<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion == accionesDialog.Ver">
  <div *ngIf="data">
    <mat-tab-group>

      <!-- Tab 1: Información General -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">info</mat-icon>
          General
        </ng-template>

        <mat-card>
          <mat-card-content>
            <div class="row">
              <div class="col"><mat-card>
                  <mat-card-header>
                    <div mat-card-avatar>
                      <mat-icon>title</mat-icon>
                    </div>
                    <mat-card-title>Información Básica</mat-card-title>
                    <mat-card-subtitle></mat-card-subtitle>
                  </mat-card-header>
                  <mat-card-content>
                    <div class="property-row">
                      <span class="property-name">Descripción:</span>
                      <span class="property-value">{{ data.descripcion | titlecase }}</span>
                    </div>
                    <div class="property-row">
                      <span class="property-name">Observaciones:</span>
                      <span class="property-value">{{ data.observaciones | titlecase }}</span>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
              <div class="col">
                <mat-card appearance="outlined">
                  <mat-card-header>
                    <div mat-card-avatar>
                      <mat-icon>info</mat-icon>
                    </div>
                    <mat-card-title>Estado y Expediente</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <div class="property-row">
                      <span class="property-name">Estado de Prueba:</span>
                      <span class="property-value">{{ data.estadoPrueba?.descripcion | titlecase }}</span>
                    </div>
                    <div class="property-row">
                      <span class="property-name">Expediente:</span>
                      <span class="property-value">{{ data.expediente?.descripcion | titlecase }}</span>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </mat-tab>

      <!-- Tab 2: Personas -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">people</mat-icon>
          Personas
        </ng-template>
        <mat-card appearance="outlined">
          <mat-card-header>
            <div mat-card-avatar>
              <mat-icon>person</mat-icon>
            </div>
            <mat-card-title>Personas Involucradas</mat-card-title>
            <mat-card-subtitle></mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <div class="property-row">
              <span class="property-name">Persona Absolvente:</span>
              <span class="property-value">{{ data.personaAbsolvente?.nombreCompleto | titlecase }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Usuario Responsable:</span>
              <span class="property-value">{{ data.usuarioResponsable?.nombreCompleto | titlecase }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Tipo Interviniente:</span>
              <span class="property-value">{{ data.tipoInterviniente?.descripcion | titlecase }}</span>
            </div>
          </mat-card-content>
        </mat-card>
      </mat-tab>

      <!-- Tab 3: Fechas de Audiencia -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">event</mat-icon>
          Fechas de Audiencia
        </ng-template>
        <mat-card appearance="outlined">
          <mat-card-header>
            <div mat-card-avatar>
              <mat-icon>event</mat-icon>
            </div>
            <mat-card-title>Gestión de Audiencia Confesional</mat-card-title>
            <mat-card-subtitle></mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <div class="property-row">
              <span class="property-name">Fecha de Audiencia:</span>
              <span class="property-value">{{ data.fechaAudiencia | date:'dd/MM/yyyy' }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Fecha Cédula Presentación:</span>
              <span class="property-value">{{ data.fechaCedulaPresentacion | date:'dd/MM/yyyy' }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Fecha Cédula Notificación:</span>
              <span class="property-value">{{ data.fechaCedulaNotificacion | date:'dd/MM/yyyy' }}</span>
            </div>
          </mat-card-content>
        </mat-card>

        <!-- Información de Auditoría -->
        <div *ngIf="data.fechaAlta || data.fechaModificacion">
          <mat-card appearance="outlined" class="info-card audit-card">
            <mat-card-header>
              <mat-card-title>Información de Auditoría</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div class="property-row">
                    <span class="property-name">Fecha de Alta:</span>
                    <span class="property-value">{{ data.fechaAlta | date:'dd/MM/yyyy HH:mm' }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Creado por:</span>
                    <span class="property-value">{{ data.creadoPor?.descripcion || 'Sistema' }}</span>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="property-row">
                    <span class="property-name">Última Modificación:</span>
                    <span class="property-value">{{ data.fechaModificacion | date:'dd/MM/yyyy HH:mm' }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Modificado por:</span>
                    <span class="property-value">{{ data.modificadoPor?.descripcion }}</span>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-tab>

    </mat-tab-group>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <app-button-cancel-dialog></app-button-cancel-dialog>

  <app-button-add *ngIf="data.accion == accionesDialog.Agregar"
    [disabled]="!form.valid || !personaAbsolventeSeleccionada" (click)="agregar()">
  </app-button-add>

  <app-button-save *ngIf="data.accion == accionesDialog.Modificar"
    [disabled]="!form.valid || !personaAbsolventeSeleccionada" [isDialogClose]="true" (saveClicked)="modificar()"
    (cancelClicked)="closeDialog()">
  </app-button-save>

  <app-button-delete *ngIf="data.accion == accionesDialog.Eliminar" (click)="eliminar()" (cancelClicked)="closeDialog()"
    [isDialogClose]="true">
  </app-button-delete>
</mat-dialog-actions>
